import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE } from '../api-base.token';
import { TextMessageRequest } from './text-message-request';
import { EmailMessageRequest } from './email-message-request';

export interface MessageResponse {
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class CommunicationsHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE) private readonly apiBase: string
  ) {}

  sendTextMessage(request: TextMessageRequest): Observable<MessageResponse> {
    return this.httpClient.post<MessageResponse>(
      `${this.apiBase}/communications/text-message`,
      request
    );
  }

  sendEmail(request: EmailMessageRequest): Observable<MessageResponse> {
    return this.httpClient.post<MessageResponse>(
      `${this.apiBase}/communications/email`,
      request
    );
  }
}